<div class="d-flex flex-column h-100 w-100 arrow">
    <span class="picker-title py-1 mb-0">{{ 'PICK_COLOR' | translate }}</span>
    <div class="d-flex flex-wrap color-container justify-content-center">
        @for (color of colors; track color) {
            <button
                class="color-circle"
                tabindex="0"
                (click)="selectColor(color)"
                [ngStyle]="{'background-color': color.toString()}"
                [ngClass]="{'color-selected': color === selectedColor}"
            ></button>
        }
    </div>
    <div class="d-inline-flex justify-content-end my-auto color-buttons pb-1">
        <app-tooltip
            (click)="revert()"
            class="color-revert"
            title="{{'REVERT' | translate}}" [compact]="true">
            <ng-container icon>
          <span
              class="vismaicon vismaicon-sm vismaicon-refresh vismaicon-reverse"
          ></span>
            </ng-container>
        </app-tooltip>
    </div>
</div>
